<div class="main-page-section default_font py-3 py-md-4 px-3 px-md-4 px-lg-5 d-flex flex-column">
    <div class="flex-fill">
        <div class="breadcrumbs-section p-0 mb-3 mb-md-4 mb-lg-5">
            <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
            <span class="separator">&nbsp; &nbsp;</span>
            <img src="../../assets/images/seperator.png">
            <span class="separator">&nbsp; &nbsp;</span>
            <span class="prev-page pr-1 prev"><a routerLink="/landscaping-and-vegetation">Add New Plant/Trees
                    Information</a></span>
            <span class="separator">&nbsp; &nbsp;</span>
            <img src="../../assets/images/seperator.png">
            <span class="separator">&nbsp; &nbsp;</span>
            <span class="prev-page pr-1 prev"><a routerLink="/plant-details/{{plantId}}">Plant Details</a></span>
            <span class="separator">&nbsp; &nbsp;</span>
            <img src="../../assets/images/seperator.png">
            <span class="separator">&nbsp; &nbsp;</span>
            <span class="curr-page pl-1 breadcrumbs-section-font">Print Information and QR Code</span>
        </div>
        <div class="d-flex align-items-center justify-content-between mb-3 mb-md-4">
            <h2 class="font-weight-bold mb-3 mb-md-4">Print Information and QR Code</h2>
        </div>
        <div id="printableContent" #printableDiv>
            <div class="border border-light p-3 p-md-4 p-lg-5 mb-2 mb-md-3 pdf_box">
                <div class="d-flex align-items-center justify-content-between mb-2 mb-md-3 card_header">
                    <a [routerLink]="['/']">
                        <img src="./assets/images/capitaland-cla-logo.png" alt="">
                    </a>
                    <a [routerLink]="['/']">
                        <img src="./assets/images/logo-cla.png" alt="">
                    </a>
                </div>
                <p class="small font-weight-semibold mb-3 mb-md-4">{{plantDetails?.parkName}}</p>
                <div class="text-center d-flex flex-column align-items-center">
                    <h3 class="font-weight-bold mb-2 mb-md-3">{{plantDetails?.vegetationName}}</h3>
                    <p>({{plantDetails?.species}})</p>
                    <div class="border border-black p-3 p-md-4 mb-3 mb-md-4">
                        <!-- <img src="./assets/images/qr_code.png" alt=""> -->
                        <img [src]="plantDetails?.qrCodePath" alt="" *ngIf="plantDetails?.qrCodePath != ''"
                            style="width: 250px;">
                        <p *ngIf="plantDetails?.qrCodePath == ''">No QR code found for this plant.</p>
                    </div>
                    <p class="small mb-0">Scan this QR Code to view details about the plant</p>
                </div>
            </div>
            <!-- <p class="font-weight-semibold mb-0">Preview</p> -->
        </div>
    </div>

    <div
        class="details_footer shadow-lg py-3 py-md-4 d-flex align-items-center justify-content-end column-gap-3 mx-n3 mx-md-n4 mx-lg-n5 px-3 px-md-4 px-lg-5 mt-4 mt-md-5">
        <!-- <button class="btn btn-primary" (click)="print('printableContent')">Print</button> -->
        <button class="btn btn-primary" (click)="onPrint('printableContent')">Print</button>
    </div>
</div>